/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputChatMessageReaction
 */
export interface InputChatMessageReaction {
    /**
     * 
     * @type {string}
     * @memberof InputChatMessageReaction
     */
    reaction: string;
}

/**
 * Check if a given object implements the InputChatMessageReaction interface.
 */
export function instanceOfInputChatMessageReaction(value: object): boolean {
    if (!('reaction' in value)) return false;
    return true;
}

export function InputChatMessageReactionFromJSON(json: any): InputChatMessageReaction {
    return InputChatMessageReactionFromJSONTyped(json, false);
}

export function InputChatMessageReactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputChatMessageReaction {
    if (json == null) {
        return json;
    }
    return {
        
        'reaction': json['reaction'],
    };
}

export function InputChatMessageReactionToJSON(value?: InputChatMessageReaction | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reaction': value['reaction'],
    };
}

